<template>
  <el-form class="calc-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="calcType">
      <template slot="label">
        <span class="require-flag">*</span>
        类型
      </template>
      <el-select v-model="control.calcType" placeholder="请选择" @change="changeCalcType">
        <el-option
          v-for="item in calcTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="expression" v-if="control.calcType === 'NUM'">
      <template slot="label">
        <span class="require-flag">*</span>
        计算表达式
      </template>
      <expression-editor
        v-model="control.expression"
        :options="canCalcFields"
        :max-height="180"
      ></expression-editor>
    </el-form-item>
    <el-form-item prop="var1" v-if="['DATE', 'LOCATION'].includes(control.calcType)">
      <template slot="label">
        <span class="require-flag">*</span>
        计算表达式
      </template>
      <template>
        <el-select v-model="control.var1" style="width: 40%;">
          <el-option
            v-for="sControl in selectFields"
            :key="sControl._cid"
            :label="sControl.name"
            :value="sControl._cid"
          ></el-option>
        </el-select>
        <span>—</span>
        <el-select v-model="control.var2" style="width: 40%;">
          <el-option
            v-for="sControl in selectFields"
            :key="sControl._cid"
            :label="sControl.name"
            :value="sControl._cid"
          ></el-option>
        </el-select>
      </template>
    </el-form-item>
    <el-form-item v-if="control.calcType === 'OPTION'" prop="expression">
      <template slot="label">
        <span class="require-flag">*</span>
        关联选择
      </template>
      <normal-select
        style="margin-top: 4px"
        :select-list="selectList"
        :selected-item="control.expression"
        @handle-select="associationSelect"
      ></normal-select>
      <div>
        <div class="option" v-for="option in options" :key="option">
          <span v-tip>{{ option }}</span>
          <expression-editor
            v-model="control.optionValueMap[option]"
            :options="canCalcFields"
            :max-height="180"
          ></expression-editor>
        </div>
      </div>
    </el-form-item>
    <el-form-item v-if="control.calcType === 'OPTION'" prop="optionDefaultValue">
      <template slot="label">
        <span class="require-flag">*</span>
        默认赋值
      </template>
      <el-input v-model="control.optionDefaultValue"></el-input>
    </el-form-item>
    <el-form-item prop="calcUnit" v-if="['DATE', 'LOCATION'].includes(control.calcType)">
      <template slot="label">
        <span class="require-flag">*</span>
        计算单位
      </template>
      <el-select v-model="control.calcUnit" v-if="control.calcType !== 'NUM'" placeholder="请选择">
        <el-option
          v-for="item in control.calcType === 'DATE' ? dateUnitTypes : locationUnitTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="unit">
      <template slot="label">
        <span class="require-flag" v-if="['DATE', 'LOCATION'].includes(control.calcType)">*</span>
        {{ ["DATE", "LOCATION"].includes(control.calcType) ? "转换单位" : "单位" }}
      </template>
      <el-select
        v-model="control.unit"
        v-if="['DATE', 'LOCATION'].includes(control.calcType)"
        placeholder="请选择"
      >
        <el-option
          v-for="item in control.calcType === 'DATE' ? dateUnitTypes : locationUnitTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input v-else v-model="control.unit"></el-input>
    </el-form-item>
    <el-form-item prop="decimal">
      <template slot="label">
        小数
      </template>
      <el-input-number
        v-model="control.decimal"
        :step="1"
        :min="0"
        :max="10"
        size="small"
      ></el-input-number>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="showComma">
      <template slot="label">
        千分位
      </template>
      <el-checkbox v-model="control.showComma"></el-checkbox>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
    <el-form-item prop="main">
      <template slot="label">
        标题
      </template>
      <el-checkbox v-model="control.main" @change="checkChange($event)"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
import { canCalcFieldTypes } from "~/data/sheet"
import { calcTypes, dateUnitTypes, locationUnitTypes } from "../static"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import ExpressionEditor from "@/components/UIComponents/ExpressionEditor"
import { decorateSheet } from "@/utils/sheet"
export default {
  name: "calc-control",
  components: {
    NormalSelect,
    ExpressionEditor
  },
  props: {
    control: Object,
    fields: Array
  },
  data() {
    return {
      calcTypes,
      canCalcFieldTypes,
      dateUnitTypes,
      locationUnitTypes
    }
  },
  computed: {
    selectFields() {
      let controls = this.fields.filter(ctl =>
        this.control.calcType === "DATE" ? ctl._type === "time" : ctl._type === "location"
      )
      let systemTime = [{ name: "创建时间", _cid: "cat", _type: "time", timeType: "年月日时分秒" }]
      return this.control.calcType === "DATE" ? controls.concat(systemTime) : controls
    },
    decoratedSheet() {
      return decorateSheet({ controls: this.fields })
    },
    canCalcFields() {
      return this.decoratedSheet.controls
        .filter(field => field._cid != this.control._cid)
        .filter(field => {
          if (field.isField) {
            // 关联表字段不用担心递归更新问题
            return this.canCalcFieldTypes.includes(field._type) || field._type === "calc"
          }
          return (
            this.canCalcFieldTypes.includes(field._type) ||
            (field._type === "calc" && field.calcType !== "NUM")
          )
        })
        .map(field => ({
          label: field.name,
          value: "v" + field._cid
        }))
    },
    selectList() {
      return this.decoratedSheet.controls
        .filter(
          control =>
            control._type === "option" &&
            control.oneFlag &&
            ["自定义", "选项集"].includes(control.optionType)
        )
        .map(control => ({ label: control.name, value: control._cid }))
    },
    options() {
      return this.decoratedSheet.controls
        ?.find(control => control._cid === this.control.expression)
        ?.options.map(option => option.value)
    }
  },
  methods: {
    checkChange(value) {
      this.$emit("checkboxChange", "main", value)
    },
    changeCalcType(calcType) {
      if (calcType === "NUM") {
        this.control.expression = ""
      } else {
        this.control.var1 = ""
        this.control.var2 = ""
      }
      this.control.unit = ""
    },
    associationSelect(val) {
      this.control.expression = val?.value
      this.control.optionValueMap = {}
      this.options?.forEach(option => (this.control.optionValueMap[option] = null))
    }
  }
}
</script>

<style lang="scss" scoped>
.option {
  display: flex;
  align-items: center;
  margin-top: 22px;
  span {
    flex: 0 0 auto;
    margin-right: 10px;
    width: 60px;
  }
}
::v-deep {
  .el-input.is-disabled .el-input__inner {
    color: #606266;
  }
}
.calc-var-dropdown-menu {
  max-height: 300px;
  border: unset !important;
  ::v-deep {
    .popper__arrow {
      display: none;
    }
  }
}
</style>
